module.exports = __webpack_public_path__ + "media/images/athletes/4252-b20a4d5180cd02ab858ebb5fc22dec46.png";